module.exports = __webpack_public_path__ + "static/media/travolier_balck.d8e3c7ba.png";